import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { getPrintLabel } from '../api/printLabel';

export const useGetPrintLabel = (entityId: number, entityType: string): UseMutationResult<string> => {
  return useMutation({
    mutationFn: async () => {
      return await getPrintLabel(entityType, entityId);
    }
  });
};